import {combineReducers, configureStore} from "@reduxjs/toolkit"
import {useDispatch as useStoreDispatch} from "react-redux"
import auth from "./api/authSlice";
import {configurationApi} from "./api/configurationApi";
import {organizationApi} from "./api/organizationApi";
import {bookingApi} from "./api/bookingApi";
// List reducers
export const reducer = combineReducers({
    [configurationApi.reducerPath]: configurationApi.reducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [bookingApi.reducerPath]: bookingApi.reducer,
    auth
})

export type StoreState = ReturnType<typeof reducer>
export type AppDispatch = typeof store.dispatch

export const useDispatch = () => useStoreDispatch<AppDispatch>()

export const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({immutableCheck:false})
            .concat(configurationApi.middleware)
            .concat(organizationApi.middleware)
            .concat(bookingApi.middleware)
})
